class ColdChainTypeService {
  constructor (http) {
    this.http = http
  }

  async getAll () {
    return (await this.http.get('/cold-chain-types')).data
  }
}
export default ColdChainTypeService
